import { Cart } from './../cart.model';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-customer-requests-typeform',
  templateUrl: './itinerary-customer-requests-typeform.component.html',
  styleUrls: ['./itinerary-customer-requests-typeform.component.css']
})
export class ItineraryCustomerRequestsTypeformComponent implements OnInit {

  cart: Cart;

  typeformNumber: string;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.cart = this.route.parent.snapshot.data.cart;
    this.route.params.subscribe(params => {
      this.typeformNumber = params["typeformNumber"];
    });
  }

}
